import { PropsWithChildren } from 'react'

export const NoLayout = ({ children }: PropsWithChildren) => {
  return <div>{children}</div>
}
